import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import { ThreeUpImage } from './ThreeUpImage';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_ThreeUp>;
};

export const ThreeUpImageGroup = observer(function ThreeUpImageGroup({
  gridCard,
}: Props) {
  const { imagesPart } = gridCard.data!.styles!;
  const { images } = imagesPart;

  return (
    <group position={[imagesPart.position.x, imagesPart.position.y, 0]}>
      {images.map((image, index, list) => {
        const elevation = list.length - 1 - index;
        return (
          <ThreeUpImage
            key={index + image.dto.id}
            gridCard={gridCard}
            index={index}
            elevation={elevation}
          />
        );
      })}
    </group>
  );
});
